"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disclosure = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const ArrowIcon_1 = require("./ArrowIcon");
const Body_1 = require("./Body");
const Header_1 = require("./Header");
const useDisclosureContext_1 = require("./useDisclosureContext");
const theme_1 = require("../../constants/theme");
const Paragraph_1 = require("../Paragraph");
const DisclosureElement = styled_1.default.div((props) => ({
    borderBottom: props.floating ? theme_1.theme.border.style.thin : undefined,
    borderBottomLeftRadius: props.floating
        ? undefined
        : theme_1.theme.border.radius.normal,
    borderBottomRightRadius: props.floating
        ? undefined
        : theme_1.theme.border.radius.normal,
    boxShadow: props.floating ? 'none' : theme_1.theme.boxShadow.normal,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    ':not(:first-of-type)': {
        borderTop: 'none',
    },
}));
const Disclosure = ({ body, children, floating = false, header, }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const toggleIsOpen = () => setIsOpen(!isOpen);
    return ((0, jsx_runtime_1.jsx)(DisclosureElement, { floating: floating, children: (0, jsx_runtime_1.jsxs)(useDisclosureContext_1.DisclosureContext.Provider, { value: { floating, isOpen, toggleIsOpen }, children: [header && (0, jsx_runtime_1.jsx)(Header_1.Header, { icon: true, children: header }), body && ((0, jsx_runtime_1.jsx)(Body_1.Body, { children: typeof body === 'string' ? (0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { children: body }) : body })), children] }) }));
};
exports.Disclosure = Disclosure;
Disclosure.Body = Body_1.Body;
Disclosure.Header = Header_1.Header;
Disclosure.Icon = ArrowIcon_1.ArrowIcon;
__exportStar(require("./useDisclosureContext"), exports);
